import React from 'react';
import ReactDOM from 'react-dom';
import { stringify } from 'qs';
import request from './_network';
import auth from './auth';
import asserts from './asserts';
import { notification, Spin } from 'antd';
import { AddLog } from './addLog';

// map: which method can be execute. method checking.
const URL_PARAMETERS_METHOD = ['delete', 'get', 'head', 'options'];
const REQUEST_BODY_METHOD = ['post', 'put', 'patch', 'form', 'upload'];
// 用于记录需要蒙版的数量，当所有需要蒙版的请求结束后，才可以去掉蒙版
let maskStack = 0;

const getUrlName = (url) => {
  if (!asserts.isExist(url)) return '';
  const [requestApi] = url.split('?');
  const [dotDo] = requestApi.split('/').reverse();
  const apiName = dotDo.includes('.do') ? dotDo.replace('.do', '') : undefined;
  return !!apiName ? `[${apiName}]` : '';
};
/**
 * fetch resolver.
 * @param {Object} option - axios config, can be over-write default setting above.
 */
const fetch = async (options) => {
  const { silence, mask = false, ...rest } = options;
  const { method, data } = rest;
  const params = {
    ...rest,
    data: method === 'form' ? stringify(data) : data,
  };

  let maskElement = null;
  if (mask) {
    maskElement = maskElement || document.createElement('div');
    maskElement.className = 'b2b-mask';
    ReactDOM.render(React.createElement(Spin, { size: 'large' }), maskElement);
    maskStack += 1;
    !document.body.querySelector('.b2b-mask') && document.body.appendChild(maskElement);
  }

  try {
    AddLog(params);
    const response = await request({ ...params });
    const { success, status } = response;
    if (status === 401) {
      // 401 的时候， 弹出登陆窗；但是某些情况下会静默调用权限接口，此时不需要弹窗
      !silence && auth.showAuthModal();
    } else if (!success && !status) {
      !silence &&
        notification.error({
          message: '发生异常',
          description: response.message,
        });
    } else if (!success && status && status >= 300) {
      // 404 | 500 | other logical error
      !silence &&
        notification.error({
          message: `操作失败${status === 500 ? getUrlName(params.url) : ''}`,
          description: response.message,
        });
    }
    return response;
  } catch (err) {
    throw err;
  } finally {
    if (mask) {
      maskStack -= 1;
      if (maskStack === 0) {
        maskElement.remove();
      }
    }
  }
};

/**
 * generator
 */
URL_PARAMETERS_METHOD.forEach(
  (method) => (fetch[method] = (url, config) => fetch({ ...config, url, method })),
);
REQUEST_BODY_METHOD.forEach(
  (method) => (fetch[method] = (url, data, config) => fetch({ ...config, url, data, method })),
);

export default fetch;
